import $ from "jquery";
import TemplateView from "../TemplateView";
import {atImgPath} from "../atBrowserUtils";
import messageResource from "../messageResource";

export default class SortableTableHeader extends TemplateView {
    constructor($containerEl, active, asc, titleMessageKey, titleLabel = null){
        super($containerEl);
        this.active = active;
        this.asc = asc;
        this.titleLabel = !!titleMessageKey ? messageResource.getMessage(titleMessageKey) : titleLabel;
    }

    templateHtml(){
        return "<div class='sortableTableHeader'>" +
               "  <span class='titleLabel'><%-titleLabel%></span>" +
               "  <div class='arrowContainer'>" +
               "    <div class='ascArrow'><img src='<%=ascArrow%>'/> <span class='for-print-only'>&darr;</span></div>" +
               "    <div class='descArrow'><img src='<%=descArrow%>'/> <span class='for-print-only'>&uarr;</span></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender(){
        this.bindClick(function() {
            if (!this.active)
                this.active = true;
            else
                this.asc = !this.asc;

            this.update();

            $(this).trigger("click");
        });
    }

    update(){
        this.$el.toggleClass("active", this.active);
        this.$el.toggleClass("asc", this.asc);
        this.$el.toggleClass("desc", !this.asc);
    }

    templateModel(){
        return {
            ascArrow: atImgPath("taskManagement/sort-down.png"),
            descArrow: atImgPath("taskManagement/sort-up.png"),
            titleLabel: this.titleLabel
        }
    }

    isActive(){
        return this.active;
    }

    setActive(active){
        this.active = active;
        this.update();
    }

    isAsc()
    {
        return this.asc;
    }

    setAsc(asc)
    {
        this.asc = asc;
        this.update();
    }
}


// WEBPACK FOOTER //
// ./web/js/controls/SortableTableHeader.js